export const PLEDGE_TEXTS = {
  1: "I commit to minimizing waste by recycling materials whenever possible, reusing items, and reducing single-use plastics.",
  2: "I pledge to be more energy-efficient by turning off lights and appliances when not in use and using energy-efficient bulbs.",
  3: "I opt for public transportation, carpool, bike, or walk whenever feasible to reduce carbon emissions from personal vehicles.",
  4: "I pledge to conserve water by fixing leaks, taking shorter showers, and using water-saving appliances. Collect rainwater for outdoor use.",
  5: "I advocate for and support the use of renewable energy sources such as solar and wind power.",
};

export function pledgeDisplayText(pledgename, ownpledgemsz) {
  const custom = String(ownpledgemsz || "").trim();
  if (custom) return custom;
  const key = String(pledgename || "").trim();
  return PLEDGE_TEXTS[key] || PLEDGE_TEXTS[Number(key)] || "";
}
